"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.canUseNativeWinSdk = void 0;
exports.guid = guid;
exports.uniqId = exports.logWarn = exports.logInfo = exports.isZZThan9_14 = exports.isZZ = exports.isIOS = exports.isFunction = exports.isAndroid = void 0;

var _env2 = _interopRequireDefault(require("@zz-common/zz-utils/lib/env"));

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.string.replace.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.array.concat.js");

var isServer = typeof window === 'undefined';
var ua = isServer ? '' : navigator && navigator.userAgent.toLowerCase();
console.log(ua);
var isAndroid = /android/.test(ua);
exports.isAndroid = isAndroid;
var isIOS = /mac|ipod|ipad|iphone/.test(ua);
exports.isIOS = isIOS;
var isZZ = /58zhuanzhuan/i.test(ua);
exports.isZZ = isZZ;

var isFunction = function isFunction(fn) {
  return Object.prototype.toString.call(fn) === '[object Function]';
}; // export const guid = () => {
//   const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ'
//   let result = ''
//   for (let i = 32; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)]
//   return result
// }


exports.isFunction = isFunction;

function guid() {
  var d = new Date().getTime();
  var uuid = 'xxxxxxxx_xxxx_4xxx_yxxx_xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    var r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c == 'x' ? r : r & 0x3 | 0x8).toString(16);
  });
  return uuid;
}

var uniqId = function uniqId(prefix) {
  var id = guid();
  return prefix ? prefix + id : id;
};

exports.uniqId = uniqId;

var isZZThan9_14 = function isZZThan9_14() {
  try {
    var ver = _env2.default.getZZVersion(); // logInfo('getZZVersion', env.getZZVersion(), 'isZZ compareVersion', isZZ && env.compareVersion(ver, '13') >= 0)


    return isZZ && _env2.default.compareVersion(ver, '9.14.0') >= 0;
  } catch (error) {}

  return false;
};

exports.isZZThan9_14 = isZZThan9_14;

var canUseNativeWinSdk = function canUseNativeWinSdk() {
  if (isAndroid && window.top && window.top.zhuanzhuanMApplication) {
    return true;
  }

  if (isIOS && window.top && window.top.zhuanzhuanMApplicationIos) {
    return true;
  }
};

exports.canUseNativeWinSdk = canUseNativeWinSdk;
var win = isServer ? global : window;
win['__@zz/fetch__dev__'] = false;

var logInfo = function logInfo() {
  var _console;

  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  if (win['__@zz/fetch__dev__']) (_console = console).log.apply(_console, ['@zz/fetch:info:'].concat(args));
};

exports.logInfo = logInfo;

var logWarn = function logWarn() {
  var _console2, _console3;

  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  if (win['__@zz/fetch__dev__']) console.warn ? (_console2 = console).warn.apply(_console2, ['@zz/fetch:warn:'].concat(args)) : (_console3 = console).log.apply(_console3, ['@zz/fetch:warn:'].concat(args));
};

exports.logWarn = logWarn;